<template>
  <Modal v-model="cancelYmsOrderModal" :title="$t('key1004290')" width="800" :transfer="false" :mask-closable="false"
    class-name="cancelYmsOrderModalStyle" @on-visible-change="cancelYmsOrderChange">
    <Form ref="cancelYmsOrderForm" :model="cancelYmsOrderForm" :rules="ruleValidate" :label-width="120" @submit.native.prevent>
      <Row style="width: 98%;">
<!--        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item label="取消范围：" prop="cancelRange">
            <Select v-model="cancelYmsOrderForm.cancelRange" transfer>
              <Option v-for="(item, index) in cancelRangeList" :value="item.value" :key="index">{{ item.name }}</Option>
            </Select>
          </Form-item>
        </Col>-->
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1004291')" prop="invalidReason">
            <Input v-model.trim="cancelYmsOrderForm.invalidReason"
              :placeholder="$t('key1004287') + `${configCharacters()}` + $t('key1006028') + `${configCharacters()}` + $t('key1006029')"
              type="textarea" :rows="5">
            </Input>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="cancelYmsOrderForm.cancelRange === 1">
          <Form-item :label="$t('key1006030')" class="required_style_label reset_item_content">
            <div class="table_box">
              <Table
                highlight-row
                border
                max-height="520"
                :loading="tableLoading"
                :columns="tableColumns"
                :data="tableData">
              </Table>
            </div>
          </Form-item>
        </Col>
        <template v-if="cancelPrice">
          <div class="mb20">
            {{ $t('key1001077') }}
            <span class="distributorThemeColor ml3 mr4">{{ timer }}</span>
            {{ $t('key1001078') }}
            <span class="distributorThemeColor">{{ $t('key1001070') + cancelPrice + ' ' + currencyState }}</span>
            {{ $t('key1001079') }}
          </div>
          <div class="flex align-items-center mb15">
            <span class="distributorThemeColor">{{ $t('key1000233') }}</span>
            <span class="mr40">{{ formatCurrency(originalCost) + ' ' + currencyState + '；' }}</span>
            <span class="redColor">{{ $t('key1000234') }}</span>
            <span>{{ formatCurrency(refundAmount) + ' ' + currencyState }}</span>
          </div>
        </template>
        <p class="crimsonRedColor font-size-13 ml120">{{$t('key1006031')+ configCharacters() + $t('key1006032')}}</p>
      </Row>
    </Form>
    <template #footer>
      <div style="text-align: right;">
        <Button @click="cancelYmsOrderModal = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" @click="cancelYmsOrderBtn">{{ $t('key1000111') }}</Button>
      </div>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {calculateDiffTime, getOrderLogisticsConsumption, setConfigCharacters} from "@/utils/common";

export default {
  name: 'cancelYmsOrderModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      cancelYmsOrderModal: false,
      cancelYmsOrderForm: {
        cancelRange: 0, // 取消范围
        invalidReason: '', // YMS取消原因
      },
      ruleValidate: {
        /*cancelRange: [
          {required: true, message: '请选择取消范围', trigger: 'change', type: 'number'}
        ],*/
        invalidReason: [
          {required: true, message: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004287')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004288')}`, trigger: 'blur'}
        ]
      },
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000239'),
          key: 'skuInfo',
          align: 'center',
          minWidth: 200,
          render(h, params) {
            return h('div', {class: 'flex mt5 mb5'}, [
              v.tableImg(h, params, 'pictureUrl'),
              h('div', {class: 'ml5'}, [
                h('div', {class: 'flex align-items-start'}, [
                  h('p', {
                    style: {
                      width: '70px',
                      textAlign: 'right'
                    }
                  }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000100')),
                  h('p', {
                    style: {
                      flex: 1
                    }
                  }, params.row.name),
                ]),
                h('div', {class: 'flex align-items-start'}, [
                  h('p', {
                    style: {
                      width: '70px',
                      textAlign: 'right'
                    }
                  }, 'SKU：'),
                  h('p', {
                    style: {
                      flex: 1
                    }
                  }, params.row.ymsSku),
                ]),
              ])
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003803'),
          key: 'quantity',
          align: 'center',
          width: 120
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004317'),
          key: 'cancelQuantity',
          align: 'center',
          width: 130,
          render: (h, params) => {
            let quantity = params.row.quantity;
            return h('div', [
              h('InputNumber', {
                props: {
                  value: null,
                  min: 1,
                  max: quantity,
                  formatter: value => `${parseInt(value)}`
                },
                style: {
                  width: '90px',
                  textAlign: 'left'
                },
                on: {
                  'on-change': num => {
                    v.$set(v.tableData[params.index], 'cancelQuantity', parseInt(num));
                  }
                }
              })
            ]);
          }
        },
      ],
      tableData: [],
      cancelRangeList: [
        {value: 0, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006023')},
        {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006024')}
      ],
      detailData: {},
      cancelPrice: 0,
      timer: null,
      originalCost: 0,
      refundAmount: 0,
    };
  },
  methods: {
    // 初始化数据
    initCancelYmsOrderData(obj, data) {
      this.detailData = obj;
      this.tableData = data || [];
      this.originalCost = obj.totalPrice || 0;
      getOrderLogisticsConsumption(obj.ymsPackageId).then((data) => {
        if (data) {
          this.cancelPrice = data.cancelPrice || 0;
          this.refundAmount = obj.totalPrice - data.cancelPrice;
          let trackingNumberTime = obj.trackingNumberTime || '';
          if (trackingNumberTime) {
            trackingNumberTime = this.$uDate.dealTime(trackingNumberTime, 'fulltime');
            this.timer = calculateDiffTime(trackingNumberTime);
            console.log('======timer======', this.timer);
          }
        }
      });
      this.cancelYmsOrderModal = true;
    },
    // 取消订单
    cancelYmsOrderBtn() {
      let v = this;
      let {invalidHandlerCost, invalidHandlerCostCurrency, allowInvalid, status} = v.detailData;
      let invalidPlatformOrderSkus = [];
      // 部分取消
      if (v.cancelYmsOrderForm.cancelRange === 1) {
        if (v.tableData.length > 0) {
          let allTalg = v.tableData.every((item) => {
            return !item.cancelQuantity;
          });
          if (allTalg) {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006025'));
            return false;
          }
          // 取消数量总数
          let cancelQuantityTotal = v.tableData.reduce((pre, cur) => {
            return pre + cur.cancelQuantity;
          }, 0);
          // 订单数量总数
          let quantityTotal = v.tableData.reduce((pre, cur) => {
            return pre + cur.quantity;
          }, 0);
          if (cancelQuantityTotal >= quantityTotal) {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006026'));
            return false;
          }
          v.tableData.map((item) => {
            let cancelQuantity = item.cancelQuantity || 0;
            invalidPlatformOrderSkus.push({
              quantity: item.quantity - cancelQuantity,
              sku: item.ymsSku,
            });
          });
        } else {
          v.$Message.warning(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001506')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006020')}`);
          return false;
        }
      }
      // 整单取消
      else {
        invalidPlatformOrderSkus = [];
      }
      let query = {
        invalidPlatformOrderSkusBos: invalidPlatformOrderSkus,
        invalidType: v.cancelYmsOrderForm.cancelRange,
        invalidReason: v.cancelYmsOrderForm.invalidReason,
        isHand: v.detailData.isHand,
        packageCode: v.detailData.packageCode,
        ymsPackageId: v.detailData.ymsPackageId,
        ymsPlatformOrderId: v.detailData.ymsPlatformOrderId
      };
      v.$refs['cancelYmsOrderForm'].validate((valid) => {
        if (valid) {
          // allowInvalid: 1 允许标记取消   0不允许标记取消
          if (allowInvalid === 1 && status === 6) {
            v.$Modal.confirm({
              title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004290'),
              content: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006021')} ${invalidHandlerCost}${invalidHandlerCostCurrency} ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006022')}`,
              okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006027'),
              cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
              onOk: () => {
                cancelOrderFun(query);
              },
              onCancel: () => {
              }
            });
          } else {
            cancelOrderFun(query);
          }
        }
      });

      function cancelOrderFun(query) {
        v.axios.post(api.post_ymsDistributorPackageInfo_cancelPackage, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001067'));
            v.cancelYmsOrderModal = false;
            v.$emit('cancelYmsOrderSuccess', data);
          }
        });
      }
    },
    // 监听弹窗
    cancelYmsOrderChange(value) {
      let v = this;
      if (!value) {
        v.tableData = [];
        v.selectTableData = [];
        v.cancelPrice = 0;
        v.originalCost = 0;
        v.refundAmount = 0;
        v.timer = null;
        v.$nextTick(() => {
          v.$refs['cancelYmsOrderForm'].resetFields();
        });
      }
    },
  },
  watch: {},
};
</script>

<style lang="less">

</style>
